import { StyledSocialLink, StyledSocialContainer, StyledWrapper } from './page-share.styles';
import { PageShareProps, SocialName } from './page-share.types';
import { useSocialLinks } from './use-social-links';
export const PageShare = ({
  description,
  url,
  socialLinks = {
    [SocialName.twitter]: true,
    [SocialName.facebook]: true,
    [SocialName.linkedin]: true
  },
  campaign
}: PageShareProps): JSX.Element => {
  const filteredLinks = useSocialLinks(socialLinks);
  return <StyledWrapper data-sentry-element="StyledWrapper" data-sentry-component="PageShare" data-sentry-source-file="page-share.tsx">
      <StyledSocialContainer data-sentry-element="StyledSocialContainer" data-sentry-source-file="page-share.tsx">
        {filteredLinks.map(social => <StyledSocialLink data-social={social.name} href={social.href({
        description,
        url,
        campaign
      })} target="_blank" aria-label={description} key={social.name} data-testid={`social-link-${social.name}`}>
            <social.icon />
          </StyledSocialLink>)}
      </StyledSocialContainer>
    </StyledWrapper>;
};